module.exports = __webpack_public_path__ + "img/thumb_image4.9939953a.jpg";